<div id="book-add-edit-form" [formGroup]="bookForm" class="book-add-edit-form">
  <div class="book-detail-container">
    <div class="cover-side-item">
      <span class="cover-side-container">
        <img class="cover-image" src="{{ book().coverImageUrl }}" alt="Book Cover Image">
        <div class="form-row">
          <mat-form-field class="coverImageUrl" style="width: 100%">
            <mat-label>Cover Image URL</mat-label>
            <input matInput type="url" name="coverImageUrl" placeholder="Cover Image URL"
              formControlName="coverImageUrl">
          </mat-form-field>
        </div>
      </span>
    </div>
    <div class="details-side-item">
      <span class="details-side-container">
        <div class="flex-row">
          <!--   T i t l e   -->
          <mat-form-field appearance="fill" id="title" class="row-field">
            <mat-label>Title</mat-label>
            <input matInput placeholder="Book Title" formControlName="title">
          </mat-form-field>
          <!--   T y p e   S e l e c t   -->
          <mat-form-field appearance="fill" class="row-field">
            <mat-label>Book Type</mat-label>
            <mat-select name="type" formControlName="type" #type>
              <mat-option value="Kindle eBook">Kindle eBook</mat-option>
              <mat-option value="Audible Book">Audible Book</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="flex-row">
          <!--   D e s c r i p t i o n   -->
          <mat-form-field appearance="outline" class="row-field">
            <mat-label>Description</mat-label>
            <textarea matNativeControl id="description" placeholder="Description" cdkTextareaAutosize
              [cdkAutosizeMinRows]="4" [cdkAutosizeMaxRows]="15" formControlName="description"></textarea>
          </mat-form-field>
        </div>
        <div class="flex-row">
          <!--   A u t h o r s   C h i p s   -->
          <kbm-author-chips [(authors)]="book().authors!"></kbm-author-chips>
          <!--   N a r r a t o r s   C h i p s    -->
          <kbm-narrator-chips [(narrators)]="book().narrators!"></kbm-narrator-chips>
          <!--   G e n r e s   C h i p s   -->
          <kbm-genre-chips [(genres)]="book().genres!"></kbm-genre-chips>
        </div>
        <!--   S e r i e s   C o n t a i n e r   ( R o w )   -->
        <div class="flex-row">
          <!--   E x i s t i n g   S e r i e s   -->
          <div class="series-list">
            <kbm-series-list [(series)]="book().series!"></kbm-series-list>
          </div>
        </div>
        <div class="flex-row">
          <!--   R u n n i n g   T i m e   -->
          <mat-form-field appearance="fill" class="row-field">
            @if(bookForm.value.type == 'Audible Book') {
            <mat-label>Running Time</mat-label>
            }
            @else {
            <mat-label>Page Count</mat-label>
            }
            <input matInput type="text" id="running-time" placeholder="Running Time" formControlName="runningTime">
          </mat-form-field>
          <!--   P u r c h a s e   D a t e   -->
          <mat-form-field appearance="fill" class="row-field">
            <mat-label>Purchase Date</mat-label>
            <input matInput [matDatepicker]="purchasedDP" formControlName="purchaseDate" placeholder="Purchase Date">
            <mat-datepicker-toggle matIconSuffix [for]="purchasedDP"></mat-datepicker-toggle>
            <mat-datepicker #purchasedDP></mat-datepicker>
          </mat-form-field>
          <!--   P u b i c a t i o n   D a t e   -->
          <mat-form-field appearance="fill" class="row-field">
            <mat-label>Publication Date</mat-label>
            <input matInput [matDatepicker]="publicationdatepicker" placeholder="Publication Date"
              formControlName="publicationDate">
            <mat-datepicker-toggle matIconSuffix [for]="publicationdatepicker"></mat-datepicker-toggle>
            <mat-datepicker #publicationdatepicker></mat-datepicker>
          </mat-form-field>
          <!--   P u b l i s h e r   -->
          <mat-form-field appearance="fill" class="row-field">
            <mat-label>Publisher</mat-label>
            <input matInput type="text" placeholder="Publisher" formControlName="publisher">
          </mat-form-field>
        </div>
        <div class="flex-row">
          <!--   A d d e d   B y   S e l e c t   -->
          <div class="form-field-div">
            <mat-form-field appearance="fill" class="row-field">
              <mat-label>Added By</mat-label>
              <mat-select name="AddedBy" formControlName="addedBy">
                @for ( user of allUsers; track user) {
                <mat-option [value]="user">{{ user }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="form-field-div">
            <!--   H a s   R e a d   C h i p s   -->
            <kbm-has-read-chips [(hasRead)]="book().hasRead!"></kbm-has-read-chips>
          </div>
          <div class="form-field-div">
            <!--   I s   I n t e r e s t e d   C h i p s   -->
            <kbm-is-interested-chips [(isInterested)]="book().isInterested!"></kbm-is-interested-chips>
          </div>
        </div>
        <div class="flex-row">
          <!--   R e c o m m e n d a t i o n s   -->
          <kbm-recommendation-list class="flex-row"
            [(recommendations)]="book().recommendations!"></kbm-recommendation-list>
        </div>
        <div class="flex-row">
          <!--   A m a z o n   I D   -->
          <mat-form-field appearance="fill" class="row-field">
            <mat-label>Amazon ID</mat-label>
            <input matInput type="text" id="amazon_id" placeholder="Amazon ID" formControlName="amazon_id">
          </mat-form-field>
          <!--   A m a z o n   P a g e   U R L   -->
          <mat-form-field appearance="fill" class="row-field">
            <mat-label>Amazon Page URL</mat-label>
            <input matInput type="url" id="amazon-page" placeholder="Amazon Page URL" formControlname="amazonPageUrl">
          </mat-form-field>
        </div>
      </span>
    </div>
  </div>
  <!-- ******************************************* -->
  <!--    B o o k   S c r e e n   A c t i o n s    -->
  <!-- ******************************************* -->
  <div>
    <button mat-raised-button color="primary" name="addSaveButton"
      (click)="onActionButtonClick(crudMode() == 'CREATE'? 'ADD' : 'SAVE')">
      {{ (crudMode() == 'CREATE'? 'Add' : 'Save') }} </button>
    <button mat-raised-button color="warn" name="cancelButton" (click)="onActionButtonClick('CANCEL')">Cancel</button>
    <button mat-raised-button color="warn" name="deleteButton" (click)="onActionButtonClick('DELETE')">Delete</button>
  </div>
</div>
<div>
  <textarea style=" width: 100%; height: 15em ;">{{ getDiagnostic() | json }}</textarea>
</div>